import styled from 'styled-components';

export const GameButtonContainer = styled.div`
  position: relative;
  width: ${props => props.width ? props.width : 'auto'};
  height: ${props => props.height ? props.height : 'auto'};
`;

export const GameButton = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: ${props => props.clicked ? '5px' : '0px'};
  border-radius: 4px;
  border: solid 2px #151515;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : '#fff2d8'};
  font-family: 'Graphik LC', sans-serif;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;
  text-align: center;
  color: #151515;
  
  ${props => props.clicked ? '' : '&:hover { top: 2px }'};
`;

export const GameButtonAfterEl = styled.div`
  position: absolute;
  z-index: 1;
  top: 5px;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: solid 2px #151515;
  background-color: ${props => props.secondaryBackgroundColor ? props.secondaryBackgroundColor : '#dec38e'};
`;